import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IEEntityList, InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { UXControllerService } from '../../service/controller/ux-controller.service';
import { CosyDynaeditorControllerService } from '../../service/controller/cosy-dynaeditor-controller.service';
import { CosyAppStateDataControllerService } from '../../service/controller/cosy-app-state-data-controller.service';
import { DragulaService } from 'ng2-dragula';

//import * as _ from 'lodash';
import cloneDeep from 'lodash-es/cloneDeep';
import { FormBuilder } from '@angular/forms';
import { MaskAttributes } from 'src/app/model/asd/asd-properties/asd-attribute';
import { InterfaceElementAlignments } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-alignment';
@Component({
  selector: 'app-cosy-dynaeditor-grid',
  templateUrl: './cosy-dynaeditor-grid.component.html',
  styleUrls: ['../cosy-dynaeditor.component.css','./cosy-dynaeditor-grid.component.css']
})
export class CosyDynaeditorGridComponent implements OnInit {

  @Input() dynaEditorElement:InterfaceElement;
  @Input() dynaItem:any;
  @Output() dynaItemChange = new EventEmitter();
  @Output() saveDEData = new EventEmitter();
 
  private IE_ALIGNMENT = InterfaceElementAlignments;

  public ie: InterfaceElement;
  public ieNew : InterfaceElement;
  public availableHeaders: any[] = [];
  public visibleHeaders: any[] = [];
  public headerCode: string = 'H-';
  public showHeaderDetail: boolean;
  public isAllowSort: boolean;
  public isAllowEdit: boolean;
  public dynaHeaderForm: any;
  public isAdmin: boolean = false;
  

  constructor(private uxControllerService: UXControllerService,
              private cosyDynaeditorControllerService: CosyDynaeditorControllerService,
              private cosyAppStateDataControllerService: CosyAppStateDataControllerService,
              private formBuilder: FormBuilder,
              private dragulaService: DragulaService) { 
                dragulaService.drop("entity-items").subscribe(value => {
                 
                  if (value.target.id == 'VisibleItems') {
                    document.getElementById('H-' + value.el.id).style.visibility = 'visible';
                  }
                  if (value.target.id == 'AvailableItems') {
                    document.getElementById('H-' + value.el.id).style.visibility = 'hidden';
                  }
            this.cosyDynaeditorControllerService.dynaEditorProcessing(value, 'drag', this.dynaEditorElement['ie'], this.uxControllerService.cosyFormInitProperties);
        });
  }

  ngOnInit(){
    this.ie = this.dynaEditorElement['ie'];
    if(this.uxControllerService.isAdmin) this.isAdmin = true;
    this.loadDynaEditorData();
  }

  updateFormValues(updatedDynaForm, actionType){
    this.saveDEData.emit(updatedDynaForm);
    this.showHeaderDetail = false;
  }

  loadDynaEntityEditForm(item: any) {
      let isEditable: boolean = false;
      isEditable = (item.Editable!==null && item.Editable)? true : false;
      this.isAllowSort = true;
      this.isAllowEdit = true;

      if(item.Attributes.Mask==null){
        item.Attributes.Mask = new MaskAttributes();
      }   
      this.dynaHeaderForm = this.formBuilder.group({
        ID: [item.Name],
        displayName: [item.DisplayName],
        allowSort: [item.AllowSorting],
        isEditable: [isEditable],
        name: [item.Name],
        maskPattern: [item.Attributes.Mask.Pattern],
        maskValue: [item.Attributes.Mask.Value],
        displayFormat : [item.Attributes.DisplayFormat],
        width: [item.Attributes.Width],
        height:[item.Attributes.Height],
        alignment: [item.Attributes.Alignment]
      });
    
  }

  editdynaEditorItem(dynaEditItem: any) {
    this.dynaItem = dynaEditItem;
    this.dynaItemChange.emit(this.dynaItem);
    this.loadDynaEntityEditForm(dynaEditItem);
    this.showHeaderDetail = true;
  }

  loadDynaEditorData(){
    this.visibleHeaders = [];
    this.availableHeaders = [];
    let ieIndex: number = -1;
    this.ieNew = new InterfaceElement();
    
   // this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument =  cloneDeep(this.cosyDynaeditorControllerService.processedCASD)
    ieIndex = this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument.InterfaceElements.map(function (d) {
      return d['InterfaceElementID'];
    }).indexOf(this.ie.InterfaceElementID);
    
    if(this.ie.EntityList!=null){
      for (let h of this.ie.EntityList.HeaderItems) {
        if (h.Attributes.Visible) {
          this.visibleHeaders.push(h);
        } else {      
          this.availableHeaders.push(h);
        }
      }
      this.visibleHeaders.sort((a, b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
    }
   

      if (ieIndex < 0) {
        this.ieNew.InterfaceElementID = this.ie.InterfaceElementID;
        let ieEntityList: IEEntityList = { RowItems: null, HeaderItems: [] };
        this.ieNew.EntityList = ieEntityList;
        this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument.InterfaceElements.push(this.ieNew);
        //this.cosyAppStateDataControllerService.processedCASD.InterfaceElements.push(this.ieNew);
        this.cosyDynaeditorControllerService.processedCASD.InterfaceElements.push(this.ieNew);
        
      }
  }

}
